import React from "react";
import { ResultsProps } from "@usereactify/search";

import { Link, ProductImage } from "@bared/ui";

type SearchResultsCalloutCardProps = React.ComponentProps<
  NonNullable<ResultsProps["renderResultCardCallout"]>
>;

export const SearchResultsCalloutCard = (
  props: SearchResultsCalloutCardProps,
) => {
  return (
    <div
      data-testid={"search-result-image-card"}
      className="group"
      style={{
        gridRow: `span ${props.callout.displayRows ?? 1}`,
        gridColumn: `span ${props.callout.displayColumns ?? 1}`,
      }}
    >
      <Link href={props.callout.link} title={props.callout.title}>
        <ProductImage src={props.callout.desktopImage} sizes="33vw" />
      </Link>
    </div>
  );
};
